@if (reviews$ | async; as reviews) {
  @if (reviews.length > 0) {
    <div class="flex justify-center my-20 px-4">
      <div class="container mx-auto">
        <div class="flex flex-col items-center mb-10 text-center">
          <span class="text-[var(--primary)] font-bold text-sm uppercase tracking-widest mb-2">Testimonials</span>
          <h2 class="text-4xl font-extrabold text-gray-900">
            Customer Feedback
          </h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          @for (review of reviews; track $index) {
            <app-review
              [rating]="review.rating"
              [name]="review.user.name"
              [message]="review.message"
            ></app-review>
          }
        </div>
      </div>
    </div>
  }
}
